export const products = [
  {
    id: 1,
    img: "https://assets.iqonic.design/free-items-preview/mobileapp/NewsBlog%20App/Long%20Preview%203.webp",
    link: "https://github.com/Jedi-24/BlogApp",
    title: "Blog Application.",
  },
  {
    id: 2,
    img: "https://i.ytimg.com/vi/9iEPzbG-xLE/maxresdefault.jpg",
    link: "https://github.com/Jedi-24/GestureVolumeController",
    title: "Gesture Volume Controller.",
  },
  {
    id: 3,
    img: "https://i.pinimg.com/originals/ca/fe/8b/cafe8b7703daff253a0b1fb67e1cfa48.png",
    link: "https://textscript.herokuapp.com/",
    title: "TextScript",
  },
  {
    id: 4,
    img: "https://ichef.bbci.co.uk/news/976/cpsprodpb/135EE/production/_110124397_c8f632b2-4a1d-4a7e-bb88-f3267cad260f.jpg",
    link: "https://github.com/Beesechurgers/Behave",
    title: "Behave",
  },
];
